import JoinLeftIcon from '@mui/icons-material/JoinLeft';
import JoinLeftOutlinedIcon from '@mui/icons-material/JoinLeftOutlined';
import React from 'react';

import { SvgIconState } from 'common/components/image';
import { Box } from 'common/components/material';
import MenuItemButton from 'common/components/menu-items/MenuItemButton';
import { useRouter } from 'common/hooks';

import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import { FeatureGuard } from 'features/feature-access/components/feature-guard.component';
import { FeaturesEnum } from 'features/feature-access/features.enum';

export const MatchingEngineMenuItem: React.FC = () => {
  const { goTo } = useRouter();

  const redirectToMatchingEngine = () => {
    let pathname = AppRoutesEnum.MATCHING_ENGINE_ROOT as string;

    goTo({
      pathname,
    });
  };

  return (
    <FeatureGuard features={[{ feature: FeaturesEnum.MATCHING_ENGINE }]}>
      <MenuItemButton
        onClick={redirectToMatchingEngine}
        label="Matching Engine"
        listItemSx={{ lineHeight: '1rem' }}
      >
        <Box className="list-item-icon">
          <SvgIconState DisabledIcon={JoinLeftOutlinedIcon} ActiveIcon={JoinLeftIcon} />
        </Box>
      </MenuItemButton>
    </FeatureGuard>
  );
};
